import React, { useState, useEffect, useContext, useMemo } from 'react';
import { WebTagContext } from '../../context/WebTagContext';
import { environment } from '../../global/environment';
import { useFetch } from '../../hooks/useFetch';
import { WebTagError } from '../web-tag-error/WebTagError';

export const WebTagStep3 = () => {

    const [ dataCompleted, setDataCompleted ] = useState( false );

    const { step, 
            userData, 
            tagCar, 
            error,
            loading,
            setStep, 
            setTagCar,
            setError,
            setTransaction } = useContext(WebTagContext);
    
    
    const {
        tag,
        carRegistration,
        brand,
        brandModel,
        color,
        carYear
    } = tagCar;

    const { api_url, 
            car_brands_endpoint,
            car_models_endpoint,
            car_colors_endpoint,
            add_tag_endpoint } = environment;

    const errorTitle = 'No se pudo agregar solicitud';
    
    // useMemo(() => {
    //     useFetch( api_url, add_tag_endpoint, 'POST' )
    // }, [userData, tagCar]);

    const { response: carColors } = useFetch( api_url, car_colors_endpoint );
    const { response: carBrands } = useFetch( api_url, car_brands_endpoint );
    const { response: carModels } = useFetch( api_url, car_models_endpoint.replace( ':brand_id', brand ) );
    const { ok, response: responseAddTag } = useFetch( api_url, add_tag_endpoint, 'post', dataCompleted, setDataCompleted );

    useEffect(
        () => {
            if( ok || responseAddTag !== '' ){
                !ok && setError( responseAddTag );
                if( ok ) {
                    setStep( { current : 4 } );
                    setTransaction( { code: responseAddTag } );
                }
            }
        },
        [ ok, responseAddTag ]
    );

    useEffect(
        () => {
            setTagCar({
                ...tagCar,
                brandModel : ''
            });
        },
        [carModels]
    )

    const handleHeaderClick = () => {
        ( step.current > 3 && step.current != 4 ) &&
            setStep( { current: 3 } );
    }

    const handleChange = (e) => {
        setTagCar({
            ...tagCar,
            [e.target.name] : e.target.value
        });
    }
    
    
    const handleSubmit = (e) => {
        e.preventDefault();
        setDataCompleted( true );
    }

    return (
        <>
            <div className="step">
                    <div className="step-header">
                        <a 
                            onClick = { handleHeaderClick }
                            className="title"
                        >
                            <span className={ step.current > 3 ? "completed step-number" : "step-number"}>
                                <span>3</span>
                                </span>Identificación TAG y Auto
                        </a>
                    </div>
                    {
                        step.current === 3
                        &&
                        <form
                            onSubmit = { handleSubmit }>
                            <div className="step-container">
                                <div className="row">
                                    <div className="col-sm-6">
                                            <label className="label-holder first-child">
                        
                                                <span className="label required">TAG de Telepeaje </span>
                                                <input 
                                                    type="text" 
                                                    className="input validate-required" 
                                                    name="tag" 
                                                    value={ tag } 
                                                    placeholder="Ingrese el tag de telepeaje" 
                                                    data-minlength="" 
                                                    onChange = { handleChange }
                                                    required />
                        
                                            </label>
                                        </div>
                                        <div className="col-sm-6">
                                            <label className="label-holder second-child">
                        
                                                <span className="label required">Matrícula del Auto</span>
                        
                                                <input 
                                                    type="text" 
                                                    className="input validate-required" 
                                                    name="carRegistration" 
                                                    value={ carRegistration } 
                                                    placeholder="Ingrese la matrícula del auto" 
                                                    data-minlength="" 
                                                    onChange = { handleChange }
                                                    required />
                        
                                            </label>
                                        </div>
                                        <div className="col-sm-6">
                                            <label className="label-holder">
                                                <span className="label required">Marca</span>
                                                <span className="select-holder">
                                                    <select 
                                                        className="select  validate-required" 
                                                        name="brand" 
                                                        value={ brand }
                                                        onChange = { handleChange }
                                                        required>
                                                        <option 
                                                            disabled 
                                                            selected 
                                                            data-placeholder 
                                                            value="">
                                                                {
                                                                    loading.car_brands ?
                                                                    'Cargando...' :
                                                                    'Seleccione la marca del auto'
                                                                }
                                                        </option>
                                                        {
                                                            carBrands.map( 
                                                                carBrand => <option 
                                                                                key = { carBrand.id }
                                                                                value = { carBrand.id }>
                                                                                    { carBrand.name }
                                                                            </option>
                                                            )
                                                        }
                                                    </select>
                                                </span>
                                            </label>
                                        </div>
                                        <div className="col-sm-6">
                                            <label className="label-holder">
                                                <span className="label required">Modelo</span>
                                                <span className="select-holder">
                                                    <select 
                                                        className="select  validate-required" 
                                                        name="brandModel" 
                                                        value={ brandModel }
                                                        onChange = { handleChange }
                                                        required>
                                                        <option 
                                                            disabled 
                                                            selected 
                                                            data-placeholder 
                                                            value="">
                                                                {
                                                                    loading.car_models ?
                                                                    'Cargando...' :
                                                                    'Seleccione el modelo del auto'
                                                                }
                                                        </option>
                                                        {

                                                            !loading.car_brands &&
                                                            carModels.map(
                                                                carModel => <option
                                                                                key = { carModel.id }
                                                                                value = { carModel.id } >
                                                                                { carModel.name }
                                                                            </option>
                                                            )
                                                        }
                                                    </select>
                                                </span>
                                            </label>
                                        </div>
                                        <div className="col-sm-6">
                                            <label className="label-holder">
                                                <span className="label required">Color</span>
                                                <span className="select-holder">
                                                    <select 
                                                        className="select  validate-required" 
                                                        name="color" 
                                                        value={ color }
                                                        onChange = { handleChange }
                                                        required>
                                                        <option 
                                                            disabled 
                                                            selected 
                                                            data-placeholder 
                                                            value="">
                                                                {
                                                                    loading.car_colors ?
                                                                    'Cargando...' :
                                                                    'Seleccione color del auto'
                                                                }
                                                        </option>
                                                        {
                                                            carColors.map(
                                                                carColor => <option 
                                                                                key = { carColor.id } 
                                                                                value = { carColor.id }>
                                                                                    { carColor.name }
                                                                            </option>
                                                            )
                                                        }
                                                        <option value="rojo">Rojo</option>
                                                    </select>
                                                </span>
                                            </label>
                                        </div>
                                        <div className="col-sm-6">
                                            <label className="label-holder">
                        
                                                <span className="label required">Año</span>
                        
                                                <input 
                                                    type="number" 
                                                    className="input validate-required" 
                                                    name="carYear" 
                                                    value={ carYear }
                                                    onChange = { handleChange }
                                                    placeholder="Ingrese el año del auto" 
                                                    data-minlength="" 
                                                    required />
                        
                                            </label>
                                        </div>
                                    </div>
                            </div>
                            <div className="no-margin step-actions">
                                <button 
                                    type = "submit"
                                    className="btn-form"
                                    disabled = { loading.add_tag_request }>
                                        {  
                                            loading.add_tag_request ?
                                            'Enviando datos...' :
                                            'Continuar'
                                        }
                                </button>
                            </div>
                        </form>
                    }
                </div>
                {
                    ok == false && responseAddTag.length > 0 && 
                    <WebTagError title = { errorTitle } error = { responseAddTag } />
                }
        </>
    )
}
